import React from "react";
import { observer } from "mobx-react";
import { CircularProgress, Box } from "@mui/material";
import TerminView from "./TerminView";
import { useAppointmentsByRx } from "../../../stores/Appointment/appointment.queries";
import { TerminViewConstants } from "../TerminView";
import useStore from "../../../helpers/useStore";
import { PatientsContext } from "../../../stores/Patients/patients.provider";
import { useRxLight } from "../../../stores/Rx/rx.queries";
import { useUnpaidBadgeCount } from "../../../stores/Transactions/transaction.queries";
import { RxListItem } from "./RxListItem";

interface RxTerminViewProps {
  rxId?: string;
  patientId?: number;
  displayRxInfo?: boolean;
}

const RxTerminView: React.FC<RxTerminViewProps> = observer(
  ({
    rxId: propRxId,
    patientId: propPatientId,
    displayRxInfo = false,
  }) => {
    const patientsStore = useStore(PatientsContext);
    
    // Use props if provided, otherwise get from store
    const rxId = propRxId || patientsStore.selectedRxId;
    const patientId = propPatientId || patientsStore.selectedPatientId;
    
    const { data: appointments = [], isLoading, error } = useAppointmentsByRx(rxId || "");
    const rxData = useRxLight(rxId || undefined, patientId || 0);
    const { data: unpaidBadgeData } = useUnpaidBadgeCount(patientId || 0);

    // console.debug("RxTerminView Rendered with rxId:", rxId, "patientId:", patientId, "and appointments:", appointments);

    if (!rxId) {
      return (
        <Box p={2}>
          <span>Kein Rezept ausgewählt</span>
        </Box>
      );
    }

    if (isLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      );
    }

    if (error) {
      return (
        <Box p={2}>
          <span>Fehler beim Laden der Termine für Rx {rxId}</span>
        </Box>
      );
    }

    const isUnpaid = unpaidBadgeData?.rxs?.find(
      (unpaidRx) => unpaidRx.rxId === rxId
    );

    return (
      <>
        {displayRxInfo && rxData && (
          <Box mb={0.5}>
            <RxListItem
              rx={rxData}
              isSelected={false}
              showRxNumber={false}
              unpaidBadgeData={isUnpaid ? {
                dueAmount: isUnpaid.dueAmount,
                tarifGroup: isUnpaid.tarifGroup
              } : undefined}
            />
          </Box>
        )}
        <TerminView
          appointments={appointments}
          patientId={patientId}
          appointmentsLoading={isLoading}
          isView={TerminViewConstants.RX_VIEW}
          isContinuous={false}
          
        />
      </>
    );
  }
);

export default RxTerminView;
